import { CommonEdition, IEditionInfo } from '@/base/platform/editions';
import { RootState } from '@/base/stores/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IDocState {
    id: number;
    edition: IEditionInfo,
}

const initialState: IDocState  = {
    id: 0,
    edition: CommonEdition,
};

export const docStateSlice = createSlice({
  name: 'doc',
  initialState,
  reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        setId: (state, action: PayloadAction<number>) => {
            state.id = action.payload;
        },
        setEditionTitle: (state, action: PayloadAction<string>) => {
            state.edition.title = action.payload;
        },
        setEdition: (state, action: PayloadAction<IEditionInfo>) => {
            state.edition = action.payload;
        }
    },
})

export const { setId, setEditionTitle, setEdition } = docStateSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectDoc = (state: RootState) => state.doc;

export default docStateSlice.reducer;
